import ZJApp from '../app'
import views from './src/views'

const utils = ZJApp.ZJUtils;

const getView = function(uri) {
    const that = this;
    let path = uri.path;
    return new Promise(function (resolve, reject) {
        let arr = path.split('/');
        let controller = arr.length >= 3 ? arr[1] : 'ui';
        let action = (arr.length >= 3 ? arr[2] : arr[1]) || 'index';
        let view = null;
        utils.each(views, x=>{
            if (typeof x === 'object' && x.controller && x.action &&
                x.controller.toLowerCase() == controller.toLowerCase() &&
                x.action.toLowerCase() == action.toLowerCase()) {
                view = x;
                return false;
            }
        });
        if (view) {
            resolve(view);
        }
        else {
            reject('在插件 ' + that.name + ' 中未找到路径 ' + path);
        }
    });
};

const install = function() {
    
};

// 每一个插件必须具有 name, getView 属性。
export default {
    name: 'TourReport',
    displayName: '上报数据',
    getView,
    install
}
